// ANGULAR
import { NgModule } from '@angular/core';

// REDUX
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromWHCustomerCrudStore from './w-h-customer-crud-store.reducer';
import { WHCustomerCrudStoreEffects } from './w-h-customer-crud-store.effects';

@NgModule({
  declarations: [],
  imports: [
    StoreModule.forFeature(fromWHCustomerCrudStore.workheldCustomerCrudStoreFeatureKey, fromWHCustomerCrudStore.workheldCustomerCrudReducer),
    EffectsModule.forFeature([WHCustomerCrudStoreEffects])
  ]
})
export class WHCustomerCrudStoreModule { }
